// extracted by mini-css-extract-plugin
export default {"container":"Product_container__HB9rc","products":"Product_products__jXawm","menu":"Product_menu__zIgrp","list":"Product_list__5qxqm","product":"Product_product__qikwV"};